import type { TimelineEvent } from "../api/types";

/** Pointage poussé par le kit timesheet (webhook signé, `context_refs.source`). */
export function isKitEvent(ev: TimelineEvent): boolean {
  return (
    ev.source_type === "webhook" && ev.context_refs?.source === "timesheet-kit"
  );
}

/** Version du kit qui a poussé le pointage, si elle est connue. */
export function kitVersion(ev: TimelineEvent): string | null {
  const v = ev.context_refs?.kit_version;
  return isKitEvent(ev) && typeof v === "string" && v ? v : null;
}

/** Temps saisi à la main : ajout ou correction, même règle que TAWA
 * (domain/day_views.go, eventOrigin). */
export function isManualEvent(ev: TimelineEvent): boolean {
  const refs = ev.context_refs ?? {};
  return "manual_adjustment_reason" in refs || "correction_reason" in refs;
}
